<template>
  <div class="cb-setup-test-1">
    <div class="cb-setup-test-1__body">
      <h1 v-if="!testFailed" class="cb-heading-4" tabindex="-1" ref="title">
        To begin, put your system in test mode
      </h1>
      <h1 v-else class="cb-heading-4" tabindex="-1" ref="title">
        Let’s try that again
      </h1>
      <div v-if="!testFailed">
        <p class="cb-body-1">
          We need to ensure our monitoring center is receiving signals from your
          CellBridge.
        </p>
        <br />
        <p class="cb-body-1">
          The test usually takes no longer than 10 minutes.
          <strong>
            Note that putting the system into Test Mode won't stop the siren
            from sounding.
          </strong>
          However, it prevents ADT from responding to an alarm during the test.
        </p>
      </div>
      <div v-else>
        <p class="cb-body-1">
          Now that you have disarmed your system, and stoped the siren from
          sounding, go ahead and continue to step 2.
        </p>
      </div>
    </div>
    <div class="cb-setup-test-1__footer">
      <div class="cb-setup-test-1__footer__divider"></div>
      <div class="cb-setup-test-1__footer__button-container">
        <cb-button
          type="button"
          @click="handleNextStep"
          :loading="loading"
          :paddingLeft="true"
          >Start Test Mode</cb-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapActions, mapState } from 'vuex';
import Button from './shared/Button.vue';

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      isModalOpen: (state) => state.modal.isOpen,
      testFailed: (state) => state.testFailed,
    }),
  },
  mounted() {
    this.$refs.title.focus();
    document.title = 'CellBridge - To begin, put your system in test mode';
  },
  methods: {
    handleNextStep() {
      this.putDeviceOnTest();
      this.loading = true;
      gtag('event', 'startClick', {
        event_label: 'start test mode',
        event_category: 'step1',
        value: 1,
      });
    },
    ...mapActions(['updateSetupTestStep', 'putDeviceOnTest']),
  },
  watch: {
    isModalOpen() {
      if (this.isModalOpen) {
        this.loading = false;
      }
    },
  },
  components: {
    cbButton: Button,
  },
};
</script>

<style lang="scss" scoped>
.cb-setup-test-1 {
  .cb-heading-4 {
    margin-bottom: 12px;
  }

  &__footer {
    margin-top: 40px;

    .cb-button {
      width: 100%;
    }
  }

  @include desktop {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    &__body {
      padding: 0 40px;
      flex-grow: 1;

      .cb-heading-4 {
        font-size: 36px;
        line-height: 50px;
      }
    }

    &__footer {
      margin-top: 0;

      &__divider {
        display: block;
        height: 1px;
        background-color: $light-blue-grey;
        margin-bottom: 20px;
      }

      &__button-container {
        display: flex;
        justify-content: flex-end;

        .cb-button {
          width: auto;
        }
      }
    }
  }
}
</style>
